import { CHCUnderstandingMedicareCard } from './understanding-medicare-card.component.js';
export { CHCUnderstandingMedicareCard };

customElements.define('chcapp-understanding-medicare-card', CHCUnderstandingMedicareCard);

declare global {
  interface HTMLElementTagNameMap {
    'chcapp-understanding-medicare-card': CHCUnderstandingMedicareCard;
  }
}
